// // src/services/ApiService.js
// import axios from 'axios';
// import { endPoint } from '../constants/endPoints';

// // ======== CONFIG ========
// const BASE_URL = 'https://posapi.pro360.freemyip.com';
// // Which DB field to send in the 'DB' header:
// const DB_FIELD = 'dataDB'; // or 'baseDB'
// const COMPANY_SLICE_CANDIDATES = ['companies', 'userCompanies', 'auth'];

// const defaultHeaders = {
//   'Content-Type': 'application/json',
//   apiKey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
// };

// const multipartHeaders = {
//   'Content-Type': 'multipart/form-data',
//   apiKey: defaultHeaders.apiKey,
// };

// // ======== Helpers: resolve active company DB from localStorage ========
// function readCompanies() {
//   const direct = localStorage.getItem('userCompanies');
//   if (direct) {
//     try {
//       const parsed = JSON.parse(direct);
//       if (Array.isArray(parsed)) return parsed;
//     } catch {}
//   }
//   const pr = localStorage.getItem('persist:root');
//   if (pr) {
//     try {
//       const root = JSON.parse(pr);
//       for (const k of COMPANY_SLICE_CANDIDATES) {
//         if (root[k]) {
//           const slice = JSON.parse(root[k]); // redux-persist slices are strings
//           if (Array.isArray(slice)) return slice;
//           if (Array.isArray(slice?.list)) return slice.list;
//           if (Array.isArray(slice?.items)) return slice.items;
//           if (Array.isArray(slice?.value)) return slice.value;
//           if (slice?.company) return [slice.company];
//         }
//       }
//     } catch {}
//   }
//   return null;
// }
// function getSelectedCompanyNo() {
//   const v = localStorage.getItem('selectedCompanyNo');
//   return v ? Number(v) : null;
// }
// function getActiveCompany() {
//   const companies = readCompanies();
//   if (!companies || companies.length === 0) return null;
//   const sel = getSelectedCompanyNo();
//   if (sel) {
//     const match = companies.find((c) => Number(c.companyNo) === sel);
//     if (match) return match;
//   }
//   return companies[0];
// }
// function getActiveCompanyDb() {
//   const c = getActiveCompany();
//   return c ? c[DB_FIELD] ?? null : null;
// }

// // ======== Service ========
// class ApiService {
//   constructor() {
//     this.axiosInstance = axios.create({
//       baseURL: BASE_URL,
//       headers: defaultHeaders,
//     });

//     // refresh guards
//     this.isRefreshing = false;
//     this.refreshWaiters = [];

//     this.axiosInstance.interceptors.request.use(this.requestInterceptor);
//     this.axiosInstance.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);
//   }

//   // ===== Interceptors =====
//   requestInterceptor = (config) => {
//     const token = this.getToken();
//     const companyDb = this.getCompany(); // resolved from active company object

//     config.headers = config.headers || {};
//     config.headers['apiKey'] = defaultHeaders.apiKey;

//     if (!config.headers['Content-Type']) {
//       config.headers['Content-Type'] = defaultHeaders['Content-Type'];
//     }
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }
//     if (companyDb) {
//       config.headers['DB'] = companyDb;
//       // config.headers['DB'] = '9106';
//     }
//     return config;
//   };

//   responseInterceptor = (response) => response;

//   errorInterceptor = async (error) => {
//     const original = error.config || {};
//     if (error.response && error.response.status === 401 && !original._retried && !this.isLoginOrSignupRequest(original)) {
//       // single-flight refresh
//       if (this.isRefreshing) {
//         const newToken = await new Promise((resolve) => this.refreshWaiters.push(resolve));
//         if (newToken) {
//           original.headers = original.headers || {};
//           original.headers['Authorization'] = `Bearer ${newToken}`;
//           const companyDb = this.getCompany();
//           if (companyDb) original.headers['DB'] = companyDb;
//           original._retried = true;
//           return this.axiosInstance.request(original);
//         }
//         return Promise.reject(error);
//       }

//       try {
//         this.isRefreshing = true;
//         const newToken = await this.handleRefreshToken(); // string|null
//         // wake waiters
//         this.refreshWaiters.forEach((w) => w(newToken));
//         this.refreshWaiters = [];

//         if (newToken) {
//           original.headers = original.headers || {};
//           original.headers['Authorization'] = `Bearer ${newToken}`;
//           const companyDb = this.getCompany();
//           if (companyDb) original.headers['DB'] = companyDb;
//           original._retried = true;
//           return this.axiosInstance.request(original);
//         }
//       } catch (_) {
//         // fall through
//       } finally {
//         this.isRefreshing = false;
//       }
//     }
//     return Promise.reject(error);
//   };

//   // ================= HTTP METHODS =================
//   get(path) {
//     return this.axiosInstance.get(endPoint[path]);
//   }

//   getApiParamater(path, data) {
//     return this.axiosInstance.get(endPoint[path] + data);
//   }

//   post(path, data) {
//     return this.axiosInstance.post(endPoint[path], data);
//   }

//   put(path, data) {
//     return this.axiosInstance.put(endPoint[path], data);
//   }

//   postMultiPart(path, body) {
//     return this.axiosInstance.post(endPoint[path], body, { headers: multipartHeaders });
//   }

//   putMultiPart(path, body) {
//     return this.axiosInstance.put(endPoint[path], body, { headers: multipartHeaders });
//   }

//   delete(path, params = {}) {
//     return this.axiosInstance.delete(endPoint[path], { params });
//   }

//   deleteBody(path, body = {}) {
//     return this.axiosInstance.delete(endPoint[path], {
//       headers: { 'Content-Type': 'application/json' },
//       data: body,
//     });
//   }

//   deleteParam(path, id) {
//     if (id === undefined || id === null) throw new Error("Missing required 'id' parameter for DELETE request");
//     return this.axiosInstance.delete(`${endPoint[path]}+${id}`);
//   }

//   // ===== Auth & Tokens =====
//   getToken() {
//     return localStorage.getItem('Token');
//   }
//   setToken(token) {
//     localStorage.setItem('Token', token);
//   }
//   getRefreshToken() {
//     return localStorage.getItem('RefreshToken');
//   }
//   setRefreshToken(refreshToken) {
//     localStorage.setItem('RefreshToken', refreshToken);
//   }

//   // Resolve DB from active company (NOT a static 'DataBase' key)
//   getCompany() {
//     return getActiveCompanyDb();
//   }

//   async handleRefreshToken() {
//     try {
//       const response = await this.axiosInstance.post(endPoint['REFRESH_TOKEN'], {
//         token: this.getToken(),
//         refreshToken: this.getRefreshToken(),
//       });
//       if (response.status === 200 && response.data?.result?.token) {
//         const newToken = response.data.result.token;
//         this.setToken(newToken);
//         return newToken;
//       }
//     } catch (error) {
//       console.error('Token refresh failed', error);
//     }
//     return null;
//   }

//   // mark auth endpoints as non-refreshable (skip retry loop)
//   isLoginOrSignupRequest(config) {
//     const url = (config.url || '').toString();
//     return url.includes('USER_LOGIN') || url.includes('USER_SIGNUP') || url.includes(endPoint['USER_LOGIN']) || url.includes(endPoint['USER_SIGNUP']);
//   }
// }

// export default ApiService;

// // // src/services/ApiService.js
// // import axios from 'axios';
// // import { endPoint } from '../constants/endPoints';
// // import { openDB } from 'idb'; // IndexedDB helper library

// // // ======== CONFIG ========
// // const BASE_URL = 'https://posapi.pro360.freemyip.com';
// // // Choose which DB field your API expects in the 'DB' header:
// // const DB_FIELD = 'dataDB'; // or 'baseDB'
// // const COMPANY_SLICE_CANDIDATES = ['companies', 'userCompanies', 'auth'];

// // const defaultHeaders = {
// //   'Content-Type': 'application/json',
// //   apiKey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
// // };
// // const headersForm = {
// //   'Content-Type': 'multipart/form-data',
// //   apiKey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
// // };

// // // ======== Helpers: resolve active company DB from localStorage ========
// // function readCompanies() {
// //   // 1) direct key (array)
// //   const direct = localStorage.getItem('userCompanies');
// //   if (direct) {
// //     try {
// //       const parsed = JSON.parse(direct);
// //       if (Array.isArray(parsed)) return parsed;
// //     } catch {}
// //   }
// //   // 2) redux-persist root (double-encoded)
// //   const pr = localStorage.getItem('persist:root');
// //   if (pr) {
// //     try {
// //       const root = JSON.parse(pr);
// //       for (const k of COMPANY_SLICE_CANDIDATES) {
// //         if (root[k]) {
// //           const slice = JSON.parse(root[k]); // slices in persist:root are strings
// //           if (Array.isArray(slice)) return slice;
// //           if (Array.isArray(slice?.list)) return slice.list;
// //           if (Array.isArray(slice?.items)) return slice.items;
// //           if (Array.isArray(slice?.value)) return slice.value;
// //           if (slice?.company) return [slice.company];
// //         }
// //       }
// //     } catch {}
// //   }
// //   return null;
// // }
// // function getSelectedCompanyNo() {
// //   const v = localStorage.getItem('selectedCompanyNo');
// //   return v ? Number(v) : null;
// // }
// // function getActiveCompany() {
// //   const companies = readCompanies();
// //   if (!companies || companies.length === 0) return null;
// //   const sel = getSelectedCompanyNo();
// //   if (sel) {
// //     const match = companies.find((c) => Number(c.companyNo) === sel);
// //     if (match) return match;
// //   }
// //   return companies[0];
// // }
// // function getActiveCompanyDb() {
// //   const c = getActiveCompany();
// //   return c ? c[DB_FIELD] ?? null : null;
// // }

// // // ======== Service ========
// // class ApiService {
// //   constructor() {
// //     this.axiosInstance = axios.create({
// //       baseURL: BASE_URL,
// //       headers: defaultHeaders,
// //     });

// //     // refresh guards
// //     this.isRefreshing = false;
// //     this.refreshWaiters = [];

// //     this.axiosInstance.interceptors.request.use(this.requestInterceptor);
// //     this.axiosInstance.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);

// //     this.initDB(); // Initialize IndexedDB when the service is constructed
// //     window.addEventListener('online', this.syncData.bind(this));
// //   }

// //   // Initialize IndexedDB
// //   async initDB() {
// //     this.db = await openDB('my-app-db', 1, {
// //       upgrade(db) {
// //         if (!db.objectStoreNames.contains('orders')) db.createObjectStore('orders', { keyPath: 'id', autoIncrement: true });
// //         if (!db.objectStoreNames.contains('menus')) db.createObjectStore('menus', { keyPath: 'id', autoIncrement: true });
// //         if (!db.objectStoreNames.contains('syncQueue')) db.createObjectStore('syncQueue', { keyPath: 'id', autoIncrement: true });
// //       },
// //     });
// //   }

// //   // ===== Interceptors =====
// //   requestInterceptor = (config) => {
// //     const token = this.getToken();
// //     const company = this.getCompany(); // now resolves from active company object

// //     config.headers = config.headers || {};
// //     // always ensure apiKey
// //     config.headers['apiKey'] = defaultHeaders.apiKey;
// //     // default content type if not provided
// //     if (!config.headers['Content-Type']) {
// //       config.headers['Content-Type'] = defaultHeaders['Content-Type'];
// //     }

// //     if (token) {
// //       config.headers['Authorization'] = `Bearer ${token}`;
// //     }
// //     if (company) {
// //       config.headers['DB'] = `${company}`;
// //     }
// //     return config;
// //   };

// //   responseInterceptor = (response) => response;

// //   errorInterceptor = async (error) => {
// //     const original = error.config || {};

// //     // 401 handling with single-flight refresh & retry
// //     if (error.response && error.response.status === 401 && !original._retried && !this.isLoginOrSignupRequest(original)) {
// //       if (this.isRefreshing) {
// //         // wait for ongoing refresh
// //         const newToken = await new Promise((resolve) => this.refreshWaiters.push(resolve));
// //         if (newToken) {
// //           original.headers = original.headers || {};
// //           original.headers['Authorization'] = `Bearer ${newToken}`;
// //           const companyDb = this.getCompany();
// //           if (companyDb) original.headers['DB'] = companyDb;
// //           original._retried = true;
// //           return this.axiosInstance.request(original);
// //         }
// //         return Promise.reject(error);
// //       }

// //       try {
// //         this.isRefreshing = true;
// //         const newToken = await this.handleRefreshToken(); // returns token or null
// //         // wake waiters
// //         this.refreshWaiters.forEach((w) => w(newToken));
// //         this.refreshWaiters = [];

// //         if (newToken) {
// //           original.headers = original.headers || {};
// //           original.headers['Authorization'] = `Bearer ${newToken}`;
// //           const companyDb = this.getCompany();
// //           if (companyDb) original.headers['DB'] = companyDb;
// //           original._retried = true;
// //           return this.axiosInstance.request(original);
// //         }
// //       } catch (e) {
// //         // fall-through to reject
// //       } finally {
// //         this.isRefreshing = false;
// //       }
// //     }

// //     return Promise.reject(error);
// //   };

// //   // Check if the application is online
// //   isOnline() {
// //     return navigator.onLine;
// //   }

// //   // Offline data management for GET requests
// //   async handleOfflineGet(path) {
// //     if (path === 'GET_MENUS') {
// //       const cachedMenus = await this.db.getAll('menus');
// //       if (cachedMenus.length > 0) {
// //         return { data: { result: cachedMenus } };
// //       }
// //     } else if (path === 'GET_ORDERS') {
// //       const cachedOrders = await this.db.getAll('orders');
// //       if (cachedOrders.length > 0) {
// //         return { data: { result: cachedOrders } };
// //       }
// //     }
// //     return null;
// //   }

// //   // Offline data management for POST/PUT requests
// //   async handleOfflinePostPut(path, data, method) {
// //     await this.db.add('syncQueue', { path, data, method, createdAt: Date.now() });
// //     if (path === 'CREATE_ORDER') {
// //       await this.db.put('orders', data);
// //     } else if (path === 'CREATE_MENU') {
// //       await this.db.put('menus', data);
// //     }
// //     return { queued: true };
// //   }

// //   // Sync offline data when online
// //   async syncData() {
// //     if (this.isOnline()) {
// //       const queue = await this.db.getAll('syncQueue');
// //       for (const request of queue) {
// //         try {
// //           if (request.method === 'POST') {
// //             await this.post(request.path, request.data);
// //           } else if (request.method === 'PUT') {
// //             await this.put(request.path, request.data);
// //           }
// //           await this.db.delete('syncQueue', request.id); // Remove from queue after successful sync
// //           console.log('Request synced:', request.method, request.path);
// //         } catch (error) {
// //           console.error('Failed to sync request:', error);
// //         }
// //       }
// //     }
// //   }

// //   // ================= HTTP METHODS =================
// //   async get(path) {
// //     if (!this.isOnline()) {
// //       const offlineResponse = await this.handleOfflineGet(path);
// //       if (offlineResponse) return offlineResponse;
// //     }

// //     const response = await this.axiosInstance.get(endPoint[path]).catch((error) => {
// //       console.error('Error fetching data:', error);
// //       throw error;
// //     });

// //     // cache when online
// //     if (this.isOnline() && path === 'GET_MENUS') {
// //       const tx = this.db.transaction('menus', 'readwrite');
// //       const store = tx.objectStore('menus');
// //       await store.clear();
// //       for (const menu of response.data?.result || []) {
// //         await store.put(menu);
// //       }
// //       await tx.done;
// //     } else if (this.isOnline() && path === 'GET_ORDERS') {
// //       const tx = this.db.transaction('orders', 'readwrite');
// //       const store = tx.objectStore('orders');
// //       await store.clear();
// //       for (const order of response.data?.result || []) {
// //         await store.put(order);
// //       }
// //       await tx.done;
// //     }

// //     return response;
// //   }

// //   async getApiParamater(path, data) {
// //     if (!this.isOnline()) {
// //       console.log('Offline: Unable to fetch data with parameters.');
// //       return;
// //     }
// //     return this.axiosInstance.get(endPoint[path] + data).catch((error) => {
// //       console.error('Error fetching data with parameters:', error);
// //       throw error;
// //     });
// //   }

// //   async postMultiPart(path, body) {
// //     try {
// //       const res = await this.axiosInstance.post(endPoint[path], body, { headers: headersForm });
// //       return res;
// //     } catch (err) {
// //       return err?.response?.data?.message;
// //     }
// //   }

// //   async putMultiPart(path, body) {
// //     try {
// //       const res = await this.axiosInstance.put(endPoint[path], body, { headers: headersForm });
// //       return res;
// //     } catch (err) {
// //       return err?.response?.data?.message;
// //     }
// //   }

// //   async post(path, data) {
// //     if (!this.isOnline()) {
// //       await this.handleOfflinePostPut(path, data, 'POST');
// //       return; // queued
// //     }

// //     return this.axiosInstance.post(endPoint[path], data).catch((error) => {
// //       console.error('Error posting data:', error);
// //       throw error;
// //     });
// //   }

// //   async put(path, body) {
// //     if (!this.isOnline()) {
// //       await this.handleOfflinePostPut(path, body, 'PUT');
// //       return; // queued
// //     }

// //     try {
// //       const res = await this.axiosInstance.put(endPoint[path], body);
// //       return res;
// //     } catch (err) {
// //       return err?.response?.data?.message || err.message;
// //     }
// //   }

// //   async delete(path, params = {}) {
// //     if (!this.isOnline()) {
// //       console.log('Offline mode: DELETE request will not be processed.');
// //       return;
// //     }

// //     return this.axiosInstance.delete(endPoint[path], { params }).catch((error) => {
// //       console.error('Error deleting data:', error);
// //       throw error;
// //     });
// //   }

// //   async deleteBody(path, body = {}) {
// //     if (!this.isOnline()) {
// //       console.log('Offline mode: DELETE request will not be processed.');
// //       return;
// //     }

// //     return this.axiosInstance
// //       .delete(endPoint[path], {
// //         headers: { 'Content-Type': 'application/json' },
// //         data: body,
// //       })
// //       .catch((error) => {
// //         console.error('Error deleting data:', error);
// //         throw error;
// //       });
// //   }

// //   async deleteParam(path, id) {
// //     if (!this.isOnline()) {
// //       console.log('Offline mode: DELETE request will not be processed.');
// //       return;
// //     }
// //     if (!id) {
// //       throw new Error("Missing required 'id' parameter for DELETE request");
// //     }
// //     return this.axiosInstance.delete(`${endPoint[path]}+${id}`).catch((error) => {
// //       console.error('Error deleting data:', error);
// //       throw error;
// //     });
// //   }

// //   // ===== Auth & Tokens =====
// //   getToken() {
// //     return localStorage.getItem('Token');
// //   }
// //   setToken(token) {
// //     localStorage.setItem('Token', token);
// //   }
// //   getRefreshToken() {
// //     return localStorage.getItem('RefreshToken');
// //   }
// //   setRefreshToken(refreshToken) {
// //     localStorage.setItem('RefreshToken', refreshToken);
// //   }

// //   // Resolve DB from active company (NOT a static 'DataBase' key)
// //   getCompany() {
// //     return getActiveCompanyDb();
// //   }

// //   async handleRefreshToken() {
// //     try {
// //       const response = await this.axiosInstance.post(endPoint['REFRESH_TOKEN'], {
// //         token: this.getToken(),
// //         refreshToken: this.getRefreshToken(),
// //       });
// //       if (response.status === 200 && response.data?.result?.token) {
// //         this.setToken(response.data.result.token);
// //         return response.data.result.token;
// //       }
// //     } catch (error) {
// //       console.error('Token refresh failed', error);
// //     }
// //     return null;
// //   }

// //   // Helper to identify login/signup requests
// //   isLoginOrSignupRequest(config) {
// //     const url = (config.url || '').toString();
// //     // if your auth endpoints are actual URLs in endPoint, you can match differently; this keeps your logic
// //     return url.includes('USER_LOGIN') || url.includes('USER_SIGNUP') || url.includes(endPoint['USER_LOGIN']) || url.includes(endPoint['USER_SIGNUP']);
// //   }
// // }

// // export default ApiService;
// src/services/ApiService.js
// src/services/ApiService.js
import axios from 'axios';
import { endPoint } from '../constants/endPoints';

// ======== CONFIG ========
const BASE_URL = 'https://retailapi.apps.pro360erp.com';
const defaultHeaders = {
  'Content-Type': 'application/json',
  apiKey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
};
const multipartHeaders = {
  'Content-Type': 'multipart/form-data',
  apiKey: defaultHeaders.apiKey,
};

// ======== Helpers ========
function getActiveDb() {
  // this value was saved during login
  const activeDb = localStorage.getItem('activeDB');
  if (activeDb) return activeDb;

  // fallback: get from userCompanies
  try {
    const companies = JSON.parse(localStorage.getItem('userCompanies') || '[]');
    if (companies.length > 0) {
      const selectedCompanyNo = localStorage.getItem('selectedCompanyNo');
      const selected = companies.find((c) => String(c.companyNo) === String(selectedCompanyNo));
      if (selected) return selected.dataDB || selected.dataDb;
      return companies[0].dataDB || companies[0].dataDb;
    }
  } catch {}
  return null;
}

function getActiveBranchId() {
  return localStorage.getItem('BranchId');
}

// ======== Service ========
class ApiService {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: BASE_URL,
      headers: defaultHeaders,
    });

    this.isRefreshing = false;
    this.refreshWaiters = [];

    this.axiosInstance.interceptors.request.use(this.requestInterceptor);
    this.axiosInstance.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);
  }

  // ===== Interceptors =====
  requestInterceptor = (config) => {
    const token = this.getToken();
    const db = getActiveDb();
    const branchId = getActiveBranchId();

    config.headers = config.headers || {};
    config.headers['apiKey'] = defaultHeaders.apiKey;

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = defaultHeaders['Content-Type'];
    }
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    if (db) config.headers['DB'] = db; // 👈 always send selected/active DB
    if (branchId) config.headers['BranchId'] = String(branchId);

    return config;
  };

  responseInterceptor = (response) => response;

  errorInterceptor = async (error) => {
    const original = error.config || {};
    if (error.response && error.response.status === 401 && !original._retried && !this.isLoginOrSignupRequest(original)) {
      if (this.isRefreshing) {
        const newToken = await new Promise((resolve) => this.refreshWaiters.push(resolve));
        if (newToken) {
          original.headers = original.headers || {};
          original.headers['Authorization'] = `Bearer ${newToken}`;
          original.headers['DB'] = getActiveDb();
          original.headers['BranchId'] = String(getActiveBranchId());
          original._retried = true;
          return this.axiosInstance.request(original);
        }
        return Promise.reject(error);
      }

      try {
        this.isRefreshing = true;
        const newToken = await this.handleRefreshToken();
        this.refreshWaiters.forEach((w) => w(newToken));
        this.refreshWaiters = [];

        if (newToken) {
          original.headers = original.headers || {};
          original.headers['Authorization'] = `Bearer ${newToken}`;
          original.headers['DB'] = getActiveDb();
          original.headers['BranchId'] = String(getActiveBranchId());
          original._retried = true;
          return this.axiosInstance.request(original);
        }
      } catch {
      } finally {
        this.isRefreshing = false;
      }
    }
    return Promise.reject(error);
  };

  // ===== HTTP METHODS =====
  get(path) {
    return this.axiosInstance.get(endPoint[path]);
  }
  getApiParamater(path, data) {
    return this.axiosInstance.get(endPoint[path] + data);
  }
  post(path, data) {
    return this.axiosInstance.post(endPoint[path], data);
  }
  put(path, data) {
    return this.axiosInstance.put(endPoint[path], data);
  }
  postMultiPart(path, body) {
    return this.axiosInstance.post(endPoint[path], body, { headers: multipartHeaders });
  }
  putMultiPart(path, body) {
    return this.axiosInstance.put(endPoint[path], body, { headers: multipartHeaders });
  }
  delete(path, params = {}) {
    return this.axiosInstance.delete(endPoint[path], { params });
  }
  deleteBody(path, body = {}) {
    return this.axiosInstance.delete(endPoint[path], {
      headers: { 'Content-Type': 'application/json' },
      data: body,
    });
  }
  deleteParam(path, id) {
    if (id === undefined || id === null) throw new Error("Missing required 'id' parameter for DELETE request");
    return this.axiosInstance.delete(`${endPoint[path]}+${id}`);
  }

  // ===== Auth =====
  getToken() {
    return localStorage.getItem('Token');
  }
  setToken(token) {
    localStorage.setItem('Token', token);
  }
  getRefreshToken() {
    return localStorage.getItem('RefreshToken');
  }
  setRefreshToken(refreshToken) {
    localStorage.setItem('RefreshToken', refreshToken);
  }

  async handleRefreshToken() {
    try {
      const response = await this.axiosInstance.post(endPoint['REFRESH_TOKEN'], {
        token: this.getToken(),
        refreshToken: this.getRefreshToken(),
      });
      if (response.status === 200 && response.data?.result?.token) {
        const newToken = response.data.result.token;
        this.setToken(newToken);
        return newToken;
      }
    } catch (error) {
      console.error('Token refresh failed', error);
    }
    return null;
  }

  isLoginOrSignupRequest(config) {
    const url = (config.url || '').toString();
    return url.includes('USER_LOGIN') || url.includes('USER_SIGNUP') || url.includes(endPoint['USER_LOGIN']) || url.includes(endPoint['USER_SIGNUP']);
  }
}

export default ApiService;
